import React from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 12
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-40px'
  },
  transition: {
    duration: 0.3
  }
};
export function ObjectionsSection() {
  return <section className="w-full bg-[#0f0529] py-16 md:py-24 px-5" data-id="element-219">
      <div className="max-w-3xl mx-auto" data-id="element-220">
        <motion.div {...fadeIn} data-id="element-221">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-10" data-id="element-222">
            Tal vez estás pensando…
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-223">
          <motion.div {...fadeIn} transition={{
          duration: 0.3,
          delay: 0.04
        }} data-id="element-224">
            <ObjectionCard objection='"He intentado de todo."' response="Perfecto. Aquí no vienes a intentar. Vienes a ejecutar 5 minutos." data-id="element-225" />
          </motion.div>

          <motion.div {...fadeIn} transition={{
          duration: 0.3,
          delay: 0.06
        }} data-id="element-226">
            <ObjectionCard objection='"Yo soy inconstante."' response="No. Tú has practicado inconstancia. Y lo que se practica, se puede reentrenar." data-id="element-227" />
          </motion.div>

          <motion.div {...fadeIn} transition={{
          duration: 0.3,
          delay: 0.08
        }} data-id="element-228">
            <ObjectionCard objection='"No tengo tiempo."' response={'Entonces este producto es exactamente para ti. Tu primera meta no es "cambiar tu vida". Es no hacer cero.'} data-id="element-229" />
          </motion.div>

          <motion.div {...fadeIn} transition={{
          duration: 0.3,
          delay: 0.1
        }} data-id="element-230">
            <ObjectionCard objection='"¿Y si fallo?"' response="Vas a fallar algún día. La diferencia es que aquí no se abandona: se reinicia." data-id="element-231" />
          </motion.div>
        </div>
      </div>

      <div className="section-divider mt-16 md:mt-24" aria-hidden="true" data-id="element-232" />
    </section>;
}
function ObjectionCard({
  objection,
  response
}: {
  objection: string;
  response: string;
}) {
  return <div className="bg-white/[0.02] border border-white/5 rounded-xl p-6" data-id="element-233">
      <p className="text-white font-semibold text-lg mb-3 italic" data-id="element-234">
        {objection}
      </p>
      <p className="text-gray-300 leading-relaxed" data-id="element-235">{response}</p>
    </div>;
}